import axiosV2Instance from './axiosV2Instance';

export interface ContractParticipantV2 {
  id?: number;
  siteExecutorId: number;
  sharePercent: number;
  displayName?: string;
  userId?: number;
  userName?: string;
  isExternal?: boolean;
}

export interface ContractV2 {
  id: number;
  title: string;
  description: string;
  siteId: number;
  typeOfWorkId: number;
  typeOfWork?: { id: number; name: string; closed: boolean; section: string };
  fixedAmount: number;
  deductionPercent?: number;
  dateCreated: string;
  dateCompleted?: string;
  isActive: boolean;
  isClosed: boolean;
  participants?: ContractParticipantV2[];
}

export interface CreateContractEstimateItemV2 {
  estimateItemId: number;
  contractQuantity: number;
  deductionPercent: number;
}

export interface ContractParticipantRequestV2 {
  siteExecutorId: number;
  sharePercent: number;
}

export interface CreateContractRequestV2 {
  title: string;
  description?: string;
  /** Ручной режим */
  typeOfWorkId?: number;
  fixedAmount?: number;
  deductionPercent?: number;
  /** Режим из сметы */
  estimateId?: number;
  items?: CreateContractEstimateItemV2[];
  participants?: ContractParticipantRequestV2[];
}

export interface UpdateContractRequestV2 {
  title: string;
  description?: string;
  typeOfWorkId: number;
  fixedAmount: number;
  deductionPercent?: number;
  participants?: ContractParticipantRequestV2[];
}

class ContractsV2Api {
  async getSiteContracts(
    siteId: number,
    options?: { onlyActive?: boolean }
  ): Promise<ContractV2[]> {
    try {
      const params = new URLSearchParams();

      if (options?.onlyActive === false) {
        params.append('onlyActive', 'false');
      }

      const query = params.toString();
      const response = await axiosV2Instance.get<ContractV2[]>(
        `/sites/${siteId}/contracts${query ? `?${query}` : ''}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error fetching v2 contracts for site ${siteId}:`, error);
      throw error;
    }
  }

  async getSiteContract(siteId: number, contractId: number): Promise<ContractV2> {
    try {
      const response = await axiosV2Instance.get<ContractV2>(
        `/sites/${siteId}/contracts/${contractId}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error fetching v2 contract ${contractId} for site ${siteId}:`, error);
      throw error;
    }
  }

  async createContract(siteId: number, data: CreateContractRequestV2): Promise<ContractV2> {
    try {
      const response = await axiosV2Instance.post<ContractV2>(
        `/sites/${siteId}/contracts`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(`Error creating contract for site ${siteId}:`, error);
      throw error;
    }
  }

  async updateContract(siteId: number, contractId: number, data: UpdateContractRequestV2): Promise<ContractV2> {
    try {
      const response = await axiosV2Instance.put<ContractV2>(
        `/sites/${siteId}/contracts/${contractId}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating contract ${contractId} for site ${siteId}:`, error);
      throw error;
    }
  }
}

export const contractsV2Api = new ContractsV2Api();


